import React from "react";
import { useSelector } from 'react-redux';

import Caption from "./Caption";
import Footer from "./Footer";
import Header from "./Header";
import Body from "./Body";

import { isEmpty, noop, identity } from "lodash";

import { Order } from "./dataProvider";

export default class Grid extends React.Component {
  static defaultColumn = (column) => ({
    sortable: true,
    ...column,
  });

  static defaultProps = {
    onLoad: noop,
    columns: [],
    items: [],
    count: 0,
    hidding: false,
    adding: false,
    editing: false,
    deleting: false,
    filtering: false,
    allowCheck: false,
    allowCheckAll: true,
    onCheckAction: null,
    onAdd: noop,
    onEdit: noop,
    onRemove: noop,
    onSelectedChange: identity,
    onRowClick: noop,
    pageSizeItems: [
      { id: 10, label: "10" },
      { id: 20, label: "20" },
      { id: 50, label: "50" },
      { id: 100, label: "100" },
      { id: 1000, label: "1000" },
    ],
    toolbarButtons: [],
    pageSize: 10,
    onPageSizeChange: noop,
    page: 0,
    onPageChange: noop,
    sort: null,
    order: Order.DESC,
    onSortChange: noop,
    onOrderChange: noop,
    onFilterAdd: noop,
    onFilterRemove: noop,
    onFilterEdit: noop,
    showPaging: true,
    showNotFoundOnEmpty: false,
    defaultFilters: [],
    masterDetail: null,
    onMasterDetailOpen: noop,
    gridTooltips: { top: null, bottom: null },
  };

  state = {
    selected: [],
  };

  componentWillMount() {
    const { onLoad, onFilterLoadDefault, defaultFilters, items, loading } = this.props;

    if (!loading && !isEmpty(items)) {
      return;
    }

    if (!isEmpty(defaultFilters) && onFilterLoadDefault instanceof Function) {
      onFilterLoadDefault(defaultFilters);
    }
    onLoad();
  }

  onSelectedChange = (selected) => {
    this.setState({ selected: this.props.onSelectedChange(selected) });
  };

  render() {
    const { columns: propsColumns, showNotFoundOnEmpty, loading, showLoading, ...props } = this.props;
    const columns = { columns: propsColumns.map(Grid.defaultColumn) };

    const isEmptyItems = showNotFoundOnEmpty && this.props.items.length === 0;
    return (
      <div className="grid-wrapper">
        {/* Tooltip for the grid, if set */}
        {props.gridTooltips && props.gridTooltips.top ? (
          <div className="grid-tooltip top">{props.gridTooltips.top}</div>
        ) : null}

        {/* Caption (toolbar + filters) outside the scrollable area */}
        <div className="grid-caption">
          <Caption {...columns} {...props} selected={this.state.selected} />
        </div>

        {!isEmptyItems && <Footer {...columns} {...props} />}

        {/* Scrollable table data */}
        <div className="grid-scroll">
          <table className="grid">
            <Header
              {...columns}
              {...props}
              onSelectedChange={this.onSelectedChange}
              selected={this.state.selected}
            />
            {!isEmptyItems && (
              <Body
                {...columns}
                {...props}
                onSelectedChange={this.onSelectedChange}
                selected={this.state.selected}
              />
            )}
            {loading && showLoading && (
              <tr className="tloading">
                <td colSpan={10}>
                  Načítání dat...
                </td>
              </tr>
            )}
            {isEmptyItems && !loading && (
              <tr className="tloading">
                <td colSpan={10} style={{ fontStyle: "italic" }}>
                  Žádné záznamy
                </td>
              </tr>
            )}
          </table>
        </div>
        {!isEmptyItems && (props.count > props.pageSize) && <Footer {...columns} {...props} />}

        {/* Bottom tooltip for the grid, if set */}
        {props.gridTooltips && props.gridTooltips.bottom ? (
            <div className="grid-tooltip bottom">{props.gridTooltips.bottom}</div>
        ) : null}
      </div>
    );
  }
}
